import { RouteObject } from 'react-router-dom';
import Assignments from '../Assignments';
import { CreateAssignments, EditAssignments } from '../pages';
import { Authorize } from '@/components';
import { ROLES } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';


const AssignmentsRoutes: RouteObject[] = [
  {
    path: 'assignments',
    element: <Assignments />,
  },
  {
    path: 'assignments/create',
    element: (
      <Authorize
        permission={ROLES.INVENTORY.admin}
        fallback={<ErrorPage code={403} />}
      >
        <CreateAssignments />
      </Authorize>
    ),
  },
  {
    path: 'assignments/:id/edit',
    element: (
      <Authorize
        permission={ROLES.INVENTORY.admin}
        fallback={<ErrorPage code={403} />}
      >
        <EditAssignments />
      </Authorize>
    ),
  },
];

export default AssignmentsRoutes;
